import { render, staticRenderFns } from "./CertificateAddPage.vue?vue&type=template&id=c39c086a&scoped=true&"
import script from "./CertificateAddPage.vue?vue&type=script&lang=js&"
export * from "./CertificateAddPage.vue?vue&type=script&lang=js&"
import style0 from "./CertificateAddPage.vue?vue&type=style&index=0&id=c39c086a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39c086a",
  null
  
)

export default component.exports